import { render, staticRenderFns } from "./overviewFeratel.vue?vue&type=template&id=74722ec7&scoped=true"
import script from "./overviewFeratel.vue?vue&type=script&lang=js"
export * from "./overviewFeratel.vue?vue&type=script&lang=js"
import style0 from "./overviewFeratel.vue?vue&type=style&index=0&id=74722ec7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74722ec7",
  null
  
)

export default component.exports